import { NavLink, Outlet } from 'react-router-dom';
import { BRAND } from '../lib/branding';

const primaryNav = [
  { to: '/', label: 'Overview', end: true },
  { to: '/customer-service', label: 'Customer Service' },
  { to: '/trainers', label: 'Trainers' },
  { to: '/partners', label: 'Partners' },
  { to: '/certificates', label: 'Certificates' },
];

const secondaryNav = [{ to: '/settings/staff', label: 'Staff registry' }];

export function AppShell() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <a href="/" className="brand">
          <img src={BRAND.logo.horizontalLight} alt="Asset College" height={28} />
        </a>
        <nav className="primary-nav" aria-label="Primary">
          {primaryNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <nav className="secondary-nav" aria-label="Settings">
          {secondaryNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <span>Asset College Analytics — RTO 31718</span>
        <span>Data is derivative of source systems. aXcelerate remains the system of record.</span>
      </footer>
      <style>{shellStyles}</style>
    </div>
  );
}

const shellStyles = `
.app-shell {
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
}
.app-header {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 12px 24px;
  background: var(--ac-white);
  border-bottom: 1px solid var(--ac-grey-200);
  box-shadow: var(--ac-shadow-sm);
}
.brand { display: inline-flex; align-items: center; }
.primary-nav { display: flex; gap: 4px; }
.secondary-nav { display: flex; gap: 4px; margin-left: auto; }
.nav-link {
  padding: 8px 14px;
  border-radius: var(--ac-radius);
  color: var(--ac-grey-700);
  font-weight: 500;
}
.nav-link:hover { background: var(--ac-grey-100); text-decoration: none; }
.nav-link.active { color: var(--ac-blue-dark); background: rgba(0, 141, 210, 0.08); }
.app-main { padding: 24px; max-width: 1280px; margin: 0 auto; width: 100%; }
.app-footer {
  display: flex; justify-content: space-between; gap: 16px; flex-wrap: wrap;
  padding: 16px 24px;
  border-top: 1px solid var(--ac-grey-200);
  color: var(--ac-grey-500);
  font-size: 13px;
  background: var(--ac-white);
}
`;
